export const tooltipDefaults = {
  settings_slideshowTime: '5' //in seconds
  , settings_autoHeight: 'on'
  , settings_skin: 'skin-default'
  , settings_close_other_tooltips: 'off'
  , settings_disable_include_in_tt_array: 'off'
  , settings_show_active_in_parent: 'off'
}